import React, { useState, useEffect, useContext, createContext } from "react";
import { PurchaseList } from "../fragments.buys/PurchaseList";
import { PurchaseFilter } from "../fragments.buys/PurchaseFilter";
import { getCurrentDate } from "../../../configs/helpers";
import { OrderPurchaseReceived } from "../fragments.buys/OrderPurchaseReceived";
import { NewNoteCreditForm } from "../fragments.buys/NewNoteCreditForm";
import { ContextAuth } from "../../../contexts/ContextAuth";

const today = new Date().toISOString().split("T")[0];

const initialNoteCreditState = {
    purchaseID: "0",
    totalCost: "0",
    operationDocumentNumber: "",
    operationDate: today,
    motive: "",
};

export function PurchasePage() {
    const { auth } = useContext(ContextAuth);
    const [orders, setOrders] = useState([]);
    const [
        detailsFromOrderPurchaseReceived,
        setDetailsFromOrderPurchaseReceived,
    ] = useState([]);
    const [noteCredit, setNoteCredit] = useState(initialNoteCreditState);
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const [isNoteCreditModalOpen, setIsNoteCreditModalOpen] = useState(false);

    // Add hidden button for backwards compatibility with old click handlers
    const openOrderModal = () => setIsOrderModalOpen(true);
    const openNoteCreditModal = () => setIsNoteCreditModalOpen(true);

    const handleNoteCreditSave = () => {
        // Refresh orders after saving note credit
        document.getElementById("btn-filter")?.click();
    };

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            COMPRAS RECIBIDAS
                        </h1>
                        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                            <span>Compras</span>
                            <span className="text-gray-400">/</span>
                            <span className="font-medium text-gray-900 dark:text-white">
                                Listado
                            </span>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="max-w-full px-4">
                    <PurchaseFilter setOrders={setOrders} />

                    {/* Override PurchaseList's button to open our modal */}
                    <div
                        id="modal-order-purchase-received"
                        onClick={openOrderModal}
                        style={{ display: "none" }}
                    ></div>

                    <PurchaseList
                        orders={orders}
                        setOrders={setOrders}
                        setDetailsFromOrderPurchaseReceived={(details) => {
                            setDetailsFromOrderPurchaseReceived(details);
                            setIsOrderModalOpen(true);
                        }}
                    />

                    <OrderPurchaseReceived
                        detailsFromOrderPurchaseReceived={
                            detailsFromOrderPurchaseReceived
                        }
                        isOpen={isOrderModalOpen}
                        onClose={() => setIsOrderModalOpen(false)}
                    />

                    <NewNoteCreditForm
                        noteCredit={noteCredit}
                        setNoteCredit={setNoteCredit}
                        orders={orders}
                        initialNoteCreditState={initialNoteCreditState}
                        isOpen={isNoteCreditModalOpen}
                        onClose={() => setIsNoteCreditModalOpen(false)}
                        onSave={handleNoteCreditSave}
                    />

                    {/* Add button to open note credit modal */}
                    <button
                        id="modal-note-credit"
                        onClick={openNoteCreditModal}
                        style={{ display: "none" }}
                    ></button>
                </div>
            </section>
        </>
    );
}
